 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		19: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"0":"vendors~compounds-article-intro~compounds-modal-button~eevee-author~elements-list~hero-connected~mod~ed2285e0","1":"default~eevee-author~html-sitemap~modules-form","3":"default~html-sitemap","4":"html-sitemap","5":"hero-connected","6":"eevee-author","7":"compounds-modal-button","8":"vendors~modules-product-table~single-review","9":"single-review","10":"carousel","11":"elements-list","12":"elements-cta","13":"image-text","14":"modules-form","15":"modules-sub-navigation","16":"vendors~modules-form","17":"button-default","18":"button-link-button-link","20":"collection-footer","21":"collection-grid","22":"collection-image-grid","23":"collection-image-logo","24":"collection-inline","25":"collection-sidebar","26":"collection-tabs","27":"collection-twocol-content","28":"compounds-article-intro","29":"compounds-assurance-text","30":"compounds-author","31":"compounds-card-award-nominee","32":"compounds-click-out-form","33":"compounds-cookie-toggle","34":"compounds-countdown","35":"compounds-form-input-email","36":"compounds-form-input-text","37":"compounds-grid-grid-column","38":"compounds-grid-grid-row","39":"compounds-heading","40":"compounds-iframe","41":"compounds-logobar","42":"compounds-quote-block","43":"compounds-table","44":"compounds-video","46":"default","47":"elements-embedded-asset","48":"elements-icon-tile","49":"elements-testimonial-card","50":"elements-widget-html","51":"email-capture-form","52":"featured-posts","53":"fixed-size-grid","54":"list-item","55":"modules-assurance-bar","56":"modules-author-profile","57":"modules-collection","58":"modules-content-hero-module","59":"modules-featured-cards","60":"modules-figure-module","61":"modules-hero","62":"modules-image-callout-module","63":"modules-lead-capture-form","64":"modules-navbar","65":"modules-product-table","66":"modules-providers-logo-module","67":"modules-reviews","68":"modules-sponsored-by","69":"preview","70":"simple-category-guide-card","71":"sub-navigation-collection","72":"trustpilot","73":"trustpilot-horizontal","74":"trustpilot-micro","75":"vendors~compounds-article-intro","76":"vendors~compounds-iframe","77":"vendors~compounds-table","78":"vendors~default","79":"vendors~email-capture-form","80":"vendors~modules-author-profile","81":"vendors~modules-product-table"}[chunkId]||chunkId) + "." + {"0":"c53eecf0","1":"820b1bb9","3":"58cb4bc4","4":"28d32363","5":"84582405","6":"53219822","7":"dcbb3326","8":"f1aa2dd4","9":"755965c5","10":"4ef686dd","11":"a464d064","12":"544f580c","13":"14e76bf7","14":"4ed58f93","15":"ad40a4aa","16":"bf13d825","17":"f70c0527","18":"36654873","20":"ee24397a","21":"c2d16932","22":"8004c241","23":"2de6833b","24":"d26c44bd","25":"b9edecfa","26":"1d496c5f","27":"ce0aeb7d","28":"2337090e","29":"20b8eecd","30":"94f31121","31":"29d2aec4","32":"0e798ccb","33":"2eafe698","34":"babb9335","35":"ede65797","36":"05030a03","37":"bcc579c7","38":"0eea9e9d","39":"2c01c96f","40":"533cd5eb","41":"1479c842","42":"6b597b86","43":"c97c8fe7","44":"ec3fc2dd","46":"4bad9f3f","47":"351661c3","48":"feb60db7","49":"05dafecc","50":"9e911a2f","51":"6a55d363","52":"93961434","53":"38975cb8","54":"aa1afd6b","55":"a1db75e9","56":"18f45932","57":"77c26859","58":"5bdf8240","59":"523ab8e6","60":"584c4c6f","61":"8c3ed09e","62":"18b6a2ea","63":"c75e500c","64":"14877157","65":"5de78a42","66":"59b6eb7f","67":"a497818a","68":"cbe1d32d","69":"f4d5ed18","70":"25032778","71":"958bce0d","72":"1c0ad8c9","73":"3f7e71d1","74":"4666e1be","75":"4d82c874","76":"bc3a81e5","77":"d29090f1","78":"876521bf","79":"b9176576","80":"36e86bd9","81":"0b7ac376","82":"2cda8d6f"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://www.uswitch.com/s3/uswitch-assets-eu/recharge-eevee/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push(["ftlp",2]);
 	// run deferred modules when ready
 	return checkDeferredModules();
